import RuleDetails from "./Rules/RuleDetails";

const Home = () => (
  <>
    <RuleDetails/>
  </>
);

export default Home;
